import { XMarkIcon } from '@heroicons/react/16/solid'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import SampleBadge from '../../../../components/sample-data/sample-badge'
import { truncateCareerID } from '../../../../helpers'
import { useCopyToClipboard } from '../../../../hooks/use-copy-to-clipboard'

export default function InfoCard({
  icon,
  title,
  id,
  idLabel,
  onIdClick,
  idTooltip,
  onClickRemove,
  onClickRemoveToolTip,
  isDemo = false,
  sampleKind = 'career',
  hasCompletedOnboarding,
  isLoading,
  disabled = false
}) {
  const { copy } = useCopyToClipboard()

  return (
    <div
      style={{ opacity: disabled ? 0.3 : 1 }}
      className='relative w-full rounded-lg border-2 border-softGrey px-6 py-4'
    >
      <div className='flex w-full justify-between'>
        <div className='flex flex-row items-center gap-x-2'>
          {isLoading ? (
            <Skeleton width={30} height={30} />
          ) : (
            <div className='flex h-[30px] w-[30px] items-center justify-center rounded-md bg-paleBlue'>
              {icon}
            </div>
          )}
          <h3
            title={title}
            className='max-w-[280px] truncate whitespace-nowrap !text-left text-xl font-semibold text-darkBlack'
          >
            {isLoading ? <Skeleton width={200} /> : title}
          </h3>
        </div>
        {hasCompletedOnboarding &&
          (isLoading ? (
            <Skeleton width={16} height={16} />
          ) : (
            <XMarkIcon
              title={onClickRemoveToolTip}
              onClick={onClickRemove}
              className='size-4 cursor-pointer text-darkGrey'
            />
          ))}
      </div>
      <div className='mt-2 flex h-[26px] flex-row items-center justify-between'>
        <button
          type='button'
          className='group cursor-pointer text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600'
          onClick={async () => {
            const copied = await copy(id)
            onIdClick?.(id, copied)
          }}
          title={idTooltip}
        >
          <span className='text-base font-normal text-rockGrey transition-colors group-hover:text-primaryBlue'>
            {isLoading ? (
              <Skeleton width={150} />
            ) : (
              ` ${idLabel}: ${truncateCareerID(id)}`
            )}
          </span>
        </button>
        {isDemo &&
          (isLoading ? (
            <Skeleton width={50} height={20} />
          ) : (
            <SampleBadge kind={sampleKind} />
          ))}
      </div>
    </div>
  )
}

InfoCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  idLabel: PropTypes.string.isRequired,
  onIdClick: PropTypes.func,
  idTooltip: PropTypes.string,
  isDemo: PropTypes.bool,
  sampleKind: PropTypes.oneOf(['career', 'talent']),
  onClickRemove: PropTypes.func,
  onClickRemoveToolTip: PropTypes.string,
  hasCompletedOnboarding: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
}
